export default "__VITE_ASSET__24de3368__"